import { render } from "./BasePrice.vue?vue&type=template&id=31775c9a&scoped=true"
import script from "./BasePrice.vue?vue&type=script&lang=js"
export * from "./BasePrice.vue?vue&type=script&lang=js"

import "./BasePrice.vue?vue&type=style&index=0&id=31775c9a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-31775c9a"

export default script